(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track || this.slides.length < 2) return;
        this.index = 0;
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.dots.forEach((d) => d.addEventListener('click', () => { this.go(parseInt(d.dataset.dot, 10)); this.restart(); }));
        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => this.sync(), 60);
        }, { passive: true });
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.track.addEventListener('touchstart', () => this.stop(), { passive: true });
        this.track.addEventListener('touchend', () => this.restart(), { passive: true });
        this.track.addEventListener('touchcancel', () => this.restart(), { passive: true });
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);
        this.mark(0);
        this.start();
      }
      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }
      get canAutoplay() {
        return this.dataset.autoplay === 'true';
      }
      start() {
        if (!this.canAutoplay || this.timer) return;
        const speed = parseInt(this.dataset.speed, 10) || 5000;
        this.timer = setInterval(() => this.go(this.index + 1), speed);
      }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() { this.stop(); this.start(); }
      go(i) {
        const n = this.slides.length;
        const target = (i + n) % n;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        /* iOS Safari ігнорує програмну прокрутку контейнера зі scroll-snap — вимикаємо snap на час переходу */
        this.track.style.scrollSnapType = 'none';
        this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        clearTimeout(this.snapTimer);
        this.snapTimer = setTimeout(() => { this.track.style.scrollSnapType = ''; }, smooth ? 700 : 50);
        this.mark(target);
      }
      sync() {
        const w = this.track.clientWidth || 1;
        this.mark(Math.round(this.track.scrollLeft / w));
      }
      mark(i) {
        this.index = i;
        this.dots.forEach((d, n) => d.setAttribute('aria-selected', n === i ? 'true' : 'false'));
        this.slides.forEach((s, n) => {
          s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
          s.querySelectorAll('a, button').forEach((el) => { el.tabIndex = n === i ? 0 : -1; });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        const io = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          fetch(this.dataset.url)
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('product-recommendations');
              if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
            })
            .catch(() => {});
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
